const EnumAPBTUV = 6 // UV属性绑定
const EnumKFTTReal2 = 2 // 二维向量(double2)类型


const loadUVAction = async (nodePtr, name, path) => {
  // 创建路径动画混合器
  const mixer = await player.Native.AnimationMixer.getMixer(name)
  const clip = await player.Native.AnimationClip.getClip(mixer, name)
  const action = await player.Native.AnimationAction.clipAction(mixer, clip)

  // const clipTrackCount = await player.Native.KeyframeTrack.trackCount(clip)
  // if (clipTrackCount > 0) {
  //   await player.Native.KeyframeTrack.clearTrack(clip)
  // }

  // 创建关键帧轨道
  const trackC = await player.Native.KeyframeTrack.addTrackWithParam(clip, nodePtr, {
    name: 'trackLocalColor',
    trackType: EnumKFTTReal2,
    propertyLinkType: EnumAPBTUV,
  })

  // await player.Native.KeyframeTrack.keyClear(trackC)

  for (let i = 0; i < path.length; i += 1) {
    // 添加位置关键帧
    player.Native.KeyframeTrack.keyAppend(trackC, path[i].time, path[i].data)
  }

  // 获取动画片段控制器
  // 绑定动画片段更新通知
  player.Native.AnimationAction.bindActionUpdate(action)
  // 设置为循环模式播放
  player.Native.AnimationAction.setLoop(action, 1, -1)
  player.Native.AnimationAction.play(action)

  return {
    mixer,
    clip,
    action
  }
}

const formImg = (nodeInfo, baseData) => {
  let res = ''
  let str = ''
  if (baseData.direction) {
    str = 'l'
  } else {
    str = 'r'
  }
  if (baseData.materialType) { // 有新属性的时候
    if (nodeInfo.size) {
      res = `${baseData.img + baseData.materialType}/${nodeInfo.size}-${baseData.materialType}-${str}.png`
    } else {
      res = `${baseData.img}${str}-${baseData.materialType}.png`
    }
  } else { // 兼容旧的属性
    res = `${baseData.img + baseData.materialType}`
  }
  // console.log('nodeInfo', nodeInfo, baseData, res)
  return res
}

// 用同一张picture贴给node
const matchImg = (nodelist, picture, path) => {
  for (let i = 0; i < nodelist.length; i += 1) {
    const e = nodelist[i]
    const baseData = {
      img: `${path}/dynamicModel/pipeFlow/`,
      materialType: picture,
      direction: e.direction
    }
    const img = formImg(e, baseData)
    e.img = img
  }
}

// 用不同贴给node
const matchImgWithDiff = (nodelist, path) => {
  for (let i = 0; i < nodelist.length; i += 1) {
    const e = nodelist[i]
    const baseData = {
      img: `${path}/dynamicModel/pipeFlow/`,
      materialType: nodelist[i].material,
      direction: e.direction
    }
    const img = formImg(e, baseData)
    e.img = img
  }
}


/**
 * @param {obj} nodeInfo nodeptr，单个的node的信息
 * @param {obj} baseData 基础数据
 */
const nodesUV = async (nodeInfo, baseData) => {
  return new Promise(async (resolve) => {
    const mat = await player.Native.NodeProxy.getNodeMaterial(nodeInfo.nodePtr)
    if (mat === 0) { // 获取不到节点材质不往下走
      // reject()
    } else {
      // const copyMat = await player.Native.NodeProxy.copyMaterial(mat)
      // player.Native.NodeProxy.setNodeMaterial(nodeInfo.nodePtr, copyMat)
      const img = formImg(nodeInfo, baseData)
      // 当管道是其他颜色时，可以先打个白色上去
      await player.Native.NodeProxy.setMaterialDiffuse(mat, 0xffffffff)
      await player.Native.NodeProxy.setMaterialTexture(mat, img)
      let pathList = []
      if (nodeInfo.direction) {
        pathList = [
          { time: 0, data: [0, 0] },
          { time: nodeInfo.flowValue * 5, data: [1, 0] }
        ]
      } else {
        pathList = [
          { time: 0, data: [1, 0] },
          { time: nodeInfo.flowValue * 5, data: [0, 0] }
        ]
      }
      // loadUVAction(nodeInfo.nodePtr, nodeInfo.nodePtr, pathList)
      // 创建路径动画混合器
      const mixer = await player.Native.AnimationMixer.getMixer('uv')
      const clip = await player.Native.AnimationClip.getClip(mixer, nodeInfo.nodePtr)
      const action = await player.Native.AnimationAction.clipAction(mixer, clip)
      const clipTrackCount = await player.Native.KeyframeTrack.trackCount(clip)
      if (clipTrackCount > 0) {
        await player.Native.KeyframeTrack.clearTrack(clip)
      }
      // 创建关键帧轨道
      const trackC = await player.Native.KeyframeTrack.addTrackWithParam(clip, nodeInfo.nodePtr, {
        name: 'trackLocalColor',
        trackType: EnumKFTTReal2,
        propertyLinkType: EnumAPBTUV,
      })
      await player.Native.KeyframeTrack.keyClear(trackC)
      for (let i = 0; i < pathList.length; i += 1) {
        // 添加位置关键帧
        player.Native.KeyframeTrack.keyAppend(trackC, pathList[i].time, pathList[i].data)
      }
      // 获取动画片段控制器
      // 绑定动画片段更新通知
      player.Native.AnimationAction.bindActionUpdate(action)
      // 设置为循环模式播放
      player.Native.AnimationAction.setLoop(action, 1, -1)
      player.Native.AnimationAction.play(action)
      resolve()
    }
  })
}

/**
 * 将nodes数据转换为接口数据，并将激活为空的排除
 * @param {list} nodes node数据
 */
// const formNodesData = async (nodes) => {
//   const res = []
//   for (let i = 0; i < nodes.length; i += 1) {
//     if (nodes[i].activate) {
//       res.push(nodes[i].nodePtr)
//     }
//   }
//   return res
// }

const formNodesImg = async (nodesList) => {
  const res = []
  for (let i = 0; i < nodesList.length; i += 1) {
    if (nodesList[i].img) {
      const temp = {
        node: nodesList[i].nodePtr,
        imagePath: nodesList[i].img,
        color: 0xffffffff,
      }
      res.push(temp)
    }
  }
  return res
}

/**
 * 当测点值为关闭时，仅贴图，剔除出渲染列表
 * @param {list} nodes node数据
 */
const removeUselessNodes = (nodesList) => {
  for (let i = 0; i < nodesList.length; i += 1) {
    if (nodesList[i].isRenderPipeFlow) {
      nodesList[i].renderFlowValue = nodesList[i].flowValue
    } else {
      nodesList[i].renderFlowValue = 0
    }
  }
}

/**
 * 处理mixer和clip数据，clip使用nodeptr来保证唯一
 * @param {list} nodes node数据
 */
const formMixerClip = async (nodesList, mixerName) => {
  const res = []
  for (let i = 0; i < nodesList.length; i += 1) {
    res.push({
      mixer: mixerName,
      clipName: nodesList[i].nodePtr
    })
  }
  return res
}

/**
 * 处理mixer和clip数据，clip使用nodeptr来保证唯一
 * @param {list} nodes node数据
 */
const formClipAction = async (clipsList, mixerName) => {
  const res = []
  for (let i = 0; i < clipsList.length; i += 1) {
    res.push({
      mixer: mixerName,
      clip: clipsList[i]
    })
  }
  return res
}

/**
 * 批量向片段中添加轨道数据
 * @param {list} nodes node数据
 */
const formTracks = async (nodesList, clips) => {
  const res = []
  for (let i = 0; i < nodesList.length; i += 1) {
    const tempObj = {
      node: nodesList[i].nodePtr,
      clip: clips[i],
      trackParam: {
        trackType: EnumKFTTReal2,
        propertyLinkType: EnumAPBTUV,
      }
    }
    res.push(tempObj)
  }
  return res
}

/**
 * 批量向片段中添加轨道数据
 * @param {list} nodesList node数据
 */
const formKeys = async (nodesList, trackList) => {
  const res = []
  const lFlow = [
    [0, 0],
    [1, 0],
  ]
  const rFlow = [
    [1, 0],
    [0, 0],
  ]
  for (let i = 0; i < nodesList.length; i += 1) {
    const tempObj1 = {
      keyframeTrack: trackList[i],
      time: 0,
    }
    const tempObj2 = {
      keyframeTrack: trackList[i],
      time: nodesList[i].flowValue * 5,
    }
    if (nodesList[i].direction) {
      tempObj1.value = lFlow[0]
      tempObj2.value = lFlow[1]
    } else {
      tempObj1.value = rFlow[0]
      tempObj2.value = rFlow[1]
    }
    res.push(tempObj1)
    res.push(tempObj2)
  }
  return res
}


/**
 * 批量向片段中添加轨道数据
 * @param {list} nodesList node数据
 */
const formLoops = async (actionList, loop, repetition) => {
  const res = []
  for (let i = 0; i < actionList.length; i += 1) {
    res.push({
      action: actionList[i],
      loopMode: loop,
      repetitions: repetition,
    })
  }
  return res
}

/**
 * @param {obj} nodeInfo nodeptr，单个的node的信息
 * @param {obj} baseData 基础数据
 */
const batchNodesUV = async (nodes, player) => {
  // const data = new Date()
  // console.log(data, 'begin')
  // texture 设置材质
  // const nodesList = await formNodesData(nodes)
  const nodesList = await formNodesImg(nodes)
  await player.Native.NodeProxy.batchSetNodesTexture(nodesList) // 贴图
  // removeUselessNodes(nodes) // 将测点值不符合的剔出渲染列表
  // // mixer clip action
  const mixer = await player.Native.AnimationMixer.getMixer('uv')
  const mixerClipList = await formMixerClip(nodes, mixer)
  const clipsList = await player.Native.AnimationClip.getBatchClips(mixerClipList)
  const clipActionList = await formClipAction(clipsList, mixer)
  const actionList = await player.Native.AnimationAction.getBatchclipActions(clipActionList)
  // track
  await player.Native.KeyframeTrack.batchClearTrack(clipsList) // 可能造成云渲染黑屏
  const tracksParam = await formTracks(nodes, clipsList)
  const trackList = await player.Native.KeyframeTrack.batchAddTracksWithParam(tracksParam)
  await player.Native.KeyframeTrack.batchKeyClear(trackList) // 可能造成云渲染黑屏
  const trackkeysList = await formKeys(nodes, trackList)
  player.Native.KeyframeTrack.batchKeyAppend(trackkeysList)
  // play
  const loops = await formLoops(actionList, 1, -1)
  player.Native.AnimationAction.batchSetLoop(loops)
  player.Native.AnimationAction.batchPlay(actionList)
  return { clipsList }
  // const data7 = new Date()
  // console.log(data7, 'end')
}

const renderUV = async (nodes, baseData) => {
  const nodeStark = []
  for (let i = 0; i < nodes.length; i += 1) {
    if (nodes[i].activate) {
      nodeStark.push(nodesUV(nodes[i], baseData))
    }
  }
  // nodes.forEach((e) => {
  //   if (e.activate) {
  //     nodeStark.push(nodesUV(e, baseData))
  //   }
  // })
  // console.log('stark', nodeStark)
  Promise.all(nodeStark)
}

/**
 * 用后端获取到的nodes数据为准，将云渲染的数据（最主要是nodePtr）匹配上
 * 需要注意，nodes为后端获取的，treenodes为云渲染获取的，一般是匹配上的，如果改模型就会有问题
 * @param {array} nodes 后端获取到的nodes数据
 * @param {array} treeNodes 云渲染获取到的nodes数据
 */
const matchNodesTree = async (nodes, treeNodes) => {
  const res = []
  for (let i = 0; i < nodes.length; i += 1) {
    const temp = { ...nodes[i], ...treeNodes[i] }
    res.push(temp)
  }
  return res
}

/**
 * 获取index下的节点，并附上属性，给到每个节点
 * @param {num} index 需要获取的索引
 * @param {arr} treeNodes 云渲染获取到的数据
 */
const getBasicUnionByIndex = (index, treeNodes, nodeData, isRenderPipeFlow) => {
  const res = []
  // 下一个节点不为空，说明为单节点，直接返回
  // 如果为最后一个元素，则直接返回
  if (treeNodes.length - 1 === index || treeNodes[index + 1].code !== '') {
  // if (treeNodes.length - 1 === index || treeNodes[index + 1].name !== '') { // 旧版方案用name来匹配
    treeNodes[index].size = nodeData.size
    treeNodes[index].direction = nodeData.direction
    treeNodes[index].flowValue = nodeData.flowValue
    treeNodes[index].activate = true
    treeNodes[index].isRenderPipeFlow = isRenderPipeFlow
    treeNodes[index].material = nodeData.material || null
    res.push(treeNodes[index])
  } else { // 下一个节点为空，把下面空的给返回
    let tempPointer = index + 1
    let bool = true
    while (bool) {
      if (tempPointer >= treeNodes.length - 1) { // 遍历到最后一个的时候，需要直接退出
        treeNodes[tempPointer].size = nodeData.size
        treeNodes[tempPointer].direction = nodeData.direction
        treeNodes[tempPointer].flowValue = nodeData.flowValue
        treeNodes[tempPointer].activate = true
        treeNodes[index].isRenderPipeFlow = isRenderPipeFlow
        treeNodes[tempPointer].material = nodeData.material || null
        res.push(treeNodes[tempPointer])
        bool = false
      } else if (treeNodes[tempPointer].code === '') {
      // } else if (treeNodes[tempPointer].name === '') { // 旧版方案用name来匹配
        treeNodes[tempPointer].size = nodeData.size
        treeNodes[tempPointer].direction = nodeData.direction
        treeNodes[tempPointer].flowValue = nodeData.flowValue
        treeNodes[tempPointer].activate = true
        treeNodes[index].isRenderPipeFlow = isRenderPipeFlow
        treeNodes[tempPointer].material = nodeData.material || null
        res.push(treeNodes[tempPointer])
        tempPointer += 1
      } else {
        bool = false
      }
    }
  }
  return res
}

/**
 * 将nodes数据和云渲染数据进行匹配并排除
 * 此方法用于hard模式，展示时处理数据
 * @param {list} nodes node数据
 */
const matchNodesData = async (nodes, treeNodes) => {
  const res = []
  for (let i = 0; i < nodes.length; i += 1) {
    if (nodes[i].activate) {
      const temp = { ...nodes[i], ...treeNodes[i] }
      res.push(temp)
    }
  }
  return res
}

/**
 * 用后端获取到的nodes数据为准，将云渲染的数据（最主要是nodePtr）匹配上
 * 需要注意，nodes为后端获取的，treenodes为云渲染获取的
 * 此方法用于easy模式，展示时处理数据
 * @param {array} nodes 后端获取到的nodes数据,name用作唯一标识
 * @param {array} treeNodes 云渲染获取到的nodes数据
 * @param {boolean} isRenderPipeFlow 根据测点值，判断是否渲染流动效果
 */
const matchNodesTreeEasy = async (nodes, treeNodes, isRenderPipeFlow) => {
  let res = []
  nodes.forEach((o) => {
    const index = _.findIndex(treeNodes, (node) => {
      return (node.code && (node.code === o.code))
      // return node.name === o.name // 旧版方案用name来匹配
    })
    if (index !== -1) {
      const tempRes = getBasicUnionByIndex(index, treeNodes, o, isRenderPipeFlow)
      res = res.concat(tempRes)
    }
  })
  return res
}

const destroyUV = async () => {

}

/**
 * 管道流速暂不做严谨处理，用测点值变化再乘系数
 * @param {Num} minValue 最小阈值
 * @param {Num} maxValue 最大阈值
 * @param {Num} curValue 当前测点值
 * @param {Num} ele 系数
 * @returns
 */
const calcUVFlow = (minValue, maxValue, curValue, ele) => {
  let flowOffset = 0
  if (curValue <= minValue) {
    curValue = minValue
  } else if (curValue >= maxValue) {
    curValue = maxValue
  }
  // flowOffset = (maxFlowValue - minFlowValue) / (maxValue - minValue) * (curValue - minValue) + Number(minFlowValue)
  flowOffset = (curValue - minValue) * ele

  return flowOffset
}

/**
 * 判断管道是否流动。
 * @param {Num} closeValue 管道关闭阈值
 * @param {Num} curValue 当前测点值
 * @returns 是否开启流动
 */
const calcIsUVFlow = (closeValue, curValue) => {
  // 如果测点值小于等于关闭阈值,则关闭
  if (closeValue < curValue) {
    return true
  }
  return false
}

/**
 * 更新时，设置每个管道node isRenderPipeFlow属性，判断是否渲染
 * @param {Num} closeValue 管道关闭阈值
 * @param {Num} curValue 当前测点值
 * @returns 是否开启流动
 */
const changeNodePipeFlow = (nodes, isRenderPipeFlow) => {
  const res = []
  for (let i = 0; i < nodes.length; i += 1) {
    const e = nodes[i]
    e.isRenderPipeFlow = isRenderPipeFlow
    res.push(e)
  }
  return res
}

export {
  loadUVAction,
  destroyUV,
  calcUVFlow,
  renderUV,
  matchNodesTree,
  matchNodesTreeEasy,
  batchNodesUV,
  matchNodesData,
  matchImg,
  matchImgWithDiff,
  calcIsUVFlow,
  changeNodePipeFlow,
}
